<template>
  <div id="app">
    <router-view />
    <LoadingOverlay :active="loading.active" :message="loading.message" />
    <notifications position="top right" />
    <vue3-confirm-dialog />
    <DonationFaq />
  </div>
  <CookieConsent />
</template>

<script>
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import CookieConsent from '@/components/CookieConsent.vue'
import DonationFaq from './components/chat/donation-faq.vue';

export default {
  name: 'App',
  components: {
    LoadingOverlay,
    CookieConsent,
    DonationFaq
    
	},
   data() {
    return {
      loading: {
        active: false,
        message: 'Processando...'
      }
    }
  },

   provide() {
    return {
      globalLoading: {
        show: (msg = 'Processando...') => {
          this.loading.message = msg;
          this.loading.active = true;
        },
        hide: () => {
          this.loading.active = false;
        }
      }
    };
  },
}
</script>

<style scoped>
.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.logo-image {
  height: 42px!important; 
  width: auto;
  object-fit: contain;
}
</style>